import AddIcon from "@mui/icons-material/Add";
import React from "react";
import { Box, Button } from "@mui/joy";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Util } from "../Helpers/Util";
import ElevatorDialog from "../Dialogs/ElevatorDialog";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import PortalTableLayout from "../components/PortalTableLayout";

interface ElevatorListingProps {
	buildingId: string;
}

interface Elevator {
	address1: string;
	address2: string;
	buildings_id: string;
	city: string;
	days_since_last_maint: number;
	description: string;
	elevators_id: string;
	out_of_service: string;
	serial_number: string;
	state: string;
	track_maintenance: boolean;
	type: string;
	zip: string;
}

export default function ElevatorListing(props: ElevatorListingProps) {
	const [elevators, setElevators] = React.useState([] as Array<Elevator>);
	const [dialog, setDialog] = React.useState(false);
	const [eId, setEid] = React.useState("");

	React.useEffect(() => {
		getData();
	}, [props.buildingId]);

	const getData = () => {
		fetch("Building/GetElevators", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ buildingsId: props.buildingId }),
		})
			.then((x) => x.json())
			.then((x) => setElevators(x as Array<Elevator>));
	};

	return (
		<>
			<LocalizationProvider dateAdapter={AdapterDateFns}>
				{dialog && (
					<ElevatorDialog
						buildingsId={props.buildingId}
						elevatorsId={eId}
						close={() => {
							getData();
							setDialog(false);
						}}
					/>
				)}
				<PortalTableLayout
					fillHeight={false}
					toolbar={
						<Box sx={{ p: 1, alignSelf: "flex-start" }}>
							<Button
								sx={{ minWidth: 140 }}
								startDecorator={<AddIcon />}
								onClick={() => {
									setEid("");
									setDialog(true);
								}}>
								Add Elevator
							</Button>
						</Box>
					}>
					<Table stickyHeader size="small">
						<TableHead>
							<TableRow>
								<TableCell>Serial #</TableCell>
								<TableCell>Days Since Last Maint.</TableCell>
								<TableCell>Type</TableCell>
								<TableCell>Street Address</TableCell>
								<TableCell>City</TableCell>
								<TableCell>State</TableCell>
								<TableCell>Zip</TableCell>
								<TableCell>Track Maint.?</TableCell>
								<TableCell>Out of Service?</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{elevators.map((x) => (
								<TableRow
									key={x.elevators_id}
									hover
									sx={{ cursor: "pointer" }}
									onClick={() => {
										setDialog(true);
										setEid(x.elevators_id);
									}}>
									<TableCell>{x.serial_number}</TableCell>
									<TableCell>{x.days_since_last_maint}</TableCell>
									<TableCell>{x.type}</TableCell>
									<TableCell>{x.address1}</TableCell>
									<TableCell>{x.city}</TableCell>
									<TableCell>{x.state}</TableCell>
									<TableCell>{x.zip}</TableCell>
									<TableCell>{Util.Formatter(x.track_maintenance, "L")}</TableCell>
									<TableCell>{x.out_of_service}</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</PortalTableLayout>
			</LocalizationProvider>
		</>
	);
}
